import errorMessages from './errorMessages';
import {
  MAX_FILES_PER_SUBMISSION,
  MAX_FILE_SIZE_TEXT,
  FILE_REQUEST_FAQ_URL,
} from '../../constants';

type FormErrorMessage = (typeof errorMessages)[keyof typeof errorMessages];

export type FormError = FormErrorMessage & {
  values?: {
    info?: string;
    limit?: number;
    size?: string;
  };
};

export type FormErrorType =
  | 'REQUIRED_FIELD'
  | 'REQUIRED_LIST_FIELD'
  | 'REQUIRED_NUMBER_FIELD'
  | 'REQUIRED_UPLOAD_FIELD'
  | 'REQUIRED_FORM_UPLOAD_FIELD'
  | 'REQUIRED_FILE_DESCRIPTION'
  | 'FORM_INCOMPLETE'
  | 'FORM_GENERIC_ERROR_MESSAGE'
  | 'INVALID_EMAIL_ADDRESS'
  | 'NOT_A_NUMBER'
  | 'TOO_MANY_FILES'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'ITEMS_FILTERED_FROM_ADD'
  | 'INVALID_FILE_NAME'
  | 'SUBMISSION_FAILED'
  | 'SPECIAL_CHARS'
  | 'SPECIAL_CHARS_NOTIFICATION'
  | 'MAXIMUM_SELECTIONS_EXCEEDED';

const ERRORS: Record<FormErrorType, FormError> = {
  REQUIRED_FIELD: { ...errorMessages.requiredFieldErrorMessage },
  REQUIRED_LIST_FIELD: { ...errorMessages.requiredFieldErrorMessage },
  REQUIRED_NUMBER_FIELD: { ...errorMessages.requiredFieldErrorMessage },
  REQUIRED_UPLOAD_FIELD: { ...errorMessages.requiredUploadFieldErrorMessage },
  REQUIRED_FORM_UPLOAD_FIELD: { ...errorMessages.uploadRequiresFiles },
  REQUIRED_FILE_DESCRIPTION: { ...errorMessages.fileDescriptionErrorMessage },
  FORM_INCOMPLETE: errorMessages.formIncompleteErrorMessage,
  FORM_GENERIC_ERROR_MESSAGE: errorMessages.formGenericErrorMessage,
  INVALID_EMAIL_ADDRESS: { ...errorMessages.invalidEmailFieldErrorMessage },
  NOT_A_NUMBER: { ...errorMessages.notANumberErrorMessage },
  TOO_MANY_FILES: {
    ...errorMessages.tooManyFilesMessage,
    values: { limit: MAX_FILES_PER_SUBMISSION },
  },
  FILE_SIZE_LIMIT_EXCEEDED: {
    ...errorMessages.fileSizeLimitExceeded,
    values: { size: MAX_FILE_SIZE_TEXT },
  },
  ITEMS_FILTERED_FROM_ADD: errorMessages.itemsFilteredFromAddMessage,
  INVALID_FILE_NAME: {
    ...errorMessages.invalidFileNameMessage,
    values: { info: FILE_REQUEST_FAQ_URL },
  },
  SUBMISSION_FAILED: errorMessages.submissionFailedMessage,
  SPECIAL_CHARS: {
    ...errorMessages.specialCharacters,
  },
  SPECIAL_CHARS_NOTIFICATION: {
    ...errorMessages.specialCharactersNotification,
    values: { info: FILE_REQUEST_FAQ_URL },
  },
  MAXIMUM_SELECTIONS_EXCEEDED: {
    ...errorMessages.maximumSelectionsExceeded,
  },
};

export { ERRORS };
export default ERRORS;
